import { useEffect, useState } from 'react';
import { User, UserManager } from 'oidc-client';
import { oidcConfig } from './config/oidcConfig';
import { IdpToken } from '../../application/types/IdpToken';
import { useAuth } from './hooks/useAuth';
import { sessionStorageKey } from '../../application/types/storageKeys.ts';

const userManager = new UserManager({
    authority: oidcConfig.authority,
    client_id: oidcConfig.client_id,
    redirect_uri: oidcConfig.redirect_uri,
    response_type: 'code',
    scope: oidcConfig.scope,
});

const OidcCallback = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { loginIdp } = useAuth();

    useEffect(() => {
        userManager
            .signinRedirectCallback()
            .then(async (user: User) => {
                window.sessionStorage.setItem(
                    sessionStorageKey.idpIdToken,
                    JSON.stringify(user.id_token)
                );
                const tokens: IdpToken = {
                    accessToken: user.access_token,
                    refreshToken: user.refresh_token,
                    refreshTokenExpiresTime: new Date(user.expires_at * 1000),
                    idToken: user.id_token,
                };

                await loginIdp(tokens);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            {isLoading && <div className="loader"></div>}
        </div>
    );
};

export default OidcCallback;
